<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules" size="small" label-width="110px" @submit.native.prevent>
      <el-form-item label="当前价格">
        <span style="line-height: 30px">￥{{convertYuan(dialogData.row.amount)}}</span>
      </el-form-item>
      <el-form-item label="修改后价格(元)">
        <el-input-number v-model="form.amount" :precision="2" :min="0.01" :max="999999"></el-input-number>
      </el-form-item>
      <el-form-item label="修改原因" prop="remark">
        <el-input v-model="form.remark" type="textarea" :rows="5" :maxlength="255" show-word-limit resize="none"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
import {inputEmpty} from "@utils/validate";

export default {
  name: "OrderEdit",
  props: {dialogData: Object},
  data() {
    return {
      form: {
        amount: 0,
        remark: "",
      },
      rules: {
        amount: [inputEmpty("修改后价格", ['blur', 'change'])],
        remark: [inputEmpty("修改原因")],
      },
    }
  },
  created() {
    this.form.amount = +this.convertYuan(this.dialogData.row.amount);
  },
  methods: {
    confirm() {
      this.$refs["form"].validate(async isOk => {
        if (isOk) {
          const nv = {
            order_id: this.dialogData.row.id,
            remark: this.form.remark,
            amount: +this.convertFen(this.form.amount),
          };
          const res = await this.$Http.editOrder(nv);
          if (res) {
            this.msgSuccess("操作成功");
            this.$emit("finish");
            this.dialogData.visible = false;
          }
        }
      })
    }
  },
}
</script>

<style scoped>

</style>
